import React from 'react';
import { Helmet } from 'react-helmet';
import { CheckSquare, Plus, MoreHorizontal } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useToast } from '@/components/ui/use-toast';

export default function TarefasSystemPage() {
  const { toast } = useToast();

  const handleAction = () => {
    toast({
      title: "Kanban em Desenvolvimento",
      description: "🚧 This feature isn't implemented yet—but don't worry! You can request it in your next prompt! 🚀",
    });
  };

  const columns = [
    { title: "A Fazer", color: "bg-slate-100", count: 5 },
    { title: "Em Progresso", color: "bg-blue-50", count: 3 },
    { title: "Concluído", color: "bg-green-50", count: 12 }
  ];

  return (
    <div className="p-8 max-w-[1600px] mx-auto space-y-6 h-[calc(100vh-100px)] flex flex-col">
      <Helmet>
        <title>Tarefas Kanban - PROVATIO</title>
      </Helmet>

      <div className="flex items-center justify-between shrink-0">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-blue-100 rounded-lg text-[#193D6D]">
            <CheckSquare size={24} />
          </div>
          <div>
            <h1 className="text-3xl font-bold text-[#193D6D]">Quadro de Tarefas</h1>
            <p className="text-slate-500">Gerenciamento visual de atividades do sistema.</p>
          </div>
        </div>
        <Button onClick={handleAction} className="bg-[#193D6D] hover:bg-blue-800 text-white">
          <Plus className="w-4 h-4 mr-2" /> Nova Tarefa
        </Button>
      </div>

      <div className="flex-1 flex gap-6 overflow-x-auto pb-4">
        {columns.map((col, idx) => (
          <div key={idx} className={`w-80 shrink-0 rounded-xl ${col.color} border border-slate-200 flex flex-col`}>
            <div className="p-4 border-b border-slate-200/50 flex items-center justify-between">
              <h3 className="font-semibold text-slate-700">{col.title} <span className="text-slate-400 text-sm font-normal ml-2">({col.count})</span></h3>
              <Button variant="ghost" size="icon" className="h-8 w-8" onClick={handleAction}><MoreHorizontal className="w-4 h-4" /></Button>
            </div>
            <div className="p-4 flex-1 space-y-3 overflow-y-auto">
              {/* Dummy Card */}
              <div 
                className="bg-white p-4 rounded-lg shadow-sm border border-slate-200 cursor-pointer hover:border-blue-300 transition-colors"
                onClick={handleAction}
              >
                <div className="flex justify-between items-start mb-2">
                  <span className="text-xs font-medium px-2 py-1 bg-red-100 text-red-700 rounded">Alta</span>
                  <span className="text-xs text-slate-400">Hoje</span>
                </div>
                <h4 className="text-sm font-medium text-slate-800 mb-1">Analisar documentos do processo 001</h4>
                <p className="text-xs text-slate-500 mb-3 line-clamp-2">Revisar os anexos periciais anexados na última movimentação.</p>
                <div className="flex items-center justify-between">
                  <div className="w-6 h-6 rounded-full bg-[#193D6D] text-white flex items-center justify-center text-xs font-bold">
                    JP
                  </div>
                  <span className="text-xs text-slate-400">Processo #123</span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}